var timelineInfographic = {};
var timelineIcons = {};

var $aSlowMo = CustomEase.create("custom", "M0,0 C0,0 0.224,0.62 0.316,0.792 0.444,1.031 1,1 1,1");
var $aSlowOut = CustomEase.create("custom", "M0,0 C0,0.45 0.144,0.815 0.3,0.9 0.484,1 0.78,1 1,1");
var $aSlowIn = CustomEase.create("custom", "M0,0 C0.48,0 0.772,0.101 0.826,0.146 0.926,0.23 1,0.75 1,1");

function animateBlocks() {

  var countElement = 0;

  $('.block-infographic').each(function(index, element) {
    var $this = $(this);
    var $blockNumber = $this.find('.number');
    var timelineName = $this.find('.icon').data('timeline');
    var numberSplit = new SplitText($blockNumber, {type:"chars"});

    timelineInfographic[timelineName] = new TimelineLite({ paused: true })
    .add(timelineIcons[timelineName].play())
    .from($this.find('.block-bg'), 1.5, { xPercent: -100, opacity: 0, ease: Power4.easeOut }, 0)
    .staggerFrom($(numberSplit.chars), 1, { opacity:0, force3D:true, y: -20, ease:Power4.easeOut }, .25, .5)
    .from($this.find('.label'), 1.5, { opacity: 0, y: -10, ease: Power4.easeOut }, 1.5);

    new ScrollMagic.Scene({
      triggerElement: this,
      triggerHook: 0.8
    })
    .on("enter", function (event) {
      timelineInfographic[timelineName].play(0).timeScale(1);
    })
    .on("leave", function (event) {
      timelineInfographic[timelineName].reverse().timeScale(2);
    })
    .addTo(controller);

  });

}



  var timeBg = 0.75;
  var repeatDelay = 2;

  // 01 - Projects
  var $iconProjects = $('*[data-timeline="iconProjects"]');
  timelineIcons.iconProjects = new TimelineLite({ paused: true })
  .from($iconProjects.find('.board'), 1, { autoAlpha:0 }, 0);

  new ScrollMagic.Scene({
    triggerElement: $iconProjects[0],
    triggerHook: 0.8
  })
  .on("enter", function (event) {
    loopProjects.play();
  })
  .on("leave", function (event) {
    loopProjects.pause();
  })
  .addTo(controller);


  // 01 - People
  var $iconPeople = $('*[data-timeline="iconPeople"]');
  timelineIcons.iconPeople = new TimelineMax({ paused: true, repeat: -1 })
  .staggerFrom($iconPeople.find('.people'), .3, { autoAlpha:0, ease: Sine.easeIn }, 0.2)
  .to($iconPeople.find('.people'), 1.25, { autoAlpha: 0, ease: Sine.easeIn }, '+=' + repeatDelay);

  // 02 Projects
  var loopProjects = new TimelineMax({repeat: -1, delay: 0.5, paused: true})
  .from($iconProjects.find('.arrow .line'), 1, { drawSVG: 0, ease: Sine.easeIn }, 0)
  .from($iconProjects.find('.arrow .point'), .5, { autoAlpha: 0, ease: Sine.easeIn }, '-=0.3')
  .staggerFrom($iconProjects.find('.graphLines .line'), 1, { autoAlpha: 0 }, 0.3, '-=1')
  .to($iconProjects.find('.line, .point'), .75, { autoAlpha: 0 }, '+=' + repeatDelay);

  // 03 - World
  var $iconWorld = $('*[data-timeline="iconWorld"]');
  timelineIcons.iconWorld = new TimelineMax({ paused: true, repeat: -1, repeatDelay: 0.5 })
  .from($iconWorld, 1, { scale: 1.5, autoAlpha: 0, ease: Sine.easeIn }, 0)
  .to($iconWorld, 1, { autoAlpha: 0, ease: Sine.easeIn }, '+=' + repeatDelay);

  // 04 - Staff
  var $iconStaff = $('*[data-timeline="iconStaff"]');
  timelineIcons.iconStaff = new TimelineMax({ paused: true, repeat: -1 })
  .from($iconStaff.find('.hand-first'), 1, { y: -10, autoAlpha: 0 }, 0.5)
  .staggerFrom($iconStaff.find('.hand'), 1, { autoAlpha: 0 }, 0.3, 1)
  .to($iconStaff.find('.hand, .hand-first'), .75, { autoAlpha: 0 }, '+=' + repeatDelay);

  // 05 - Ideas
  var $iconIdeas = $('*[data-timeline="iconIdeas"]');
  timelineIcons.iconIdeas = new TimelineMax({ paused: true })
  .from($iconIdeas, 1, { y: -10, autoAlpha: 0, ease: Power4.easeOut });

  new ScrollMagic.Scene({
    triggerElement: $iconIdeas[0],
    triggerHook: 0.8
  })
  .on("enter", function (event) {
    loopLightLines.play();
    loopBulb.play();
  })
  .on("leave", function (event) {
    loopLightLines.pause();
    loopBulb.pause();
  })
  .addTo(controller);

  var loopLightLines = new TimelineMax({repeat: -1, repeatDelay: 2, paused: true})
  .from($iconIdeas.find('.lines-sub').find('.line'), 0.5, { drawSVG: "0 0", ease: $aSlowOut }, '+=0.5')
  .from($iconIdeas.find('.lines-sup').find('.line'), 0.5, { drawSVG: "0 0", ease: $aSlowIn }, '-=0.4')
  .to($iconIdeas.find('.lines-sub').find('.line'), 0.5, { drawSVG: "100% 100%", ease: $aSlowOut })
  .to($iconIdeas.find('.lines-sup').find('.line'), 0.5, { drawSVG: "100% 100%", ease: $aSlowOut }, '-=0.5');

  var loopBulb = new TimelineMax({repeat: -1, repeatDelay: 2, paused: true})
  .from($iconIdeas.find('.bulb'), 0.8, { scale: 0.9, rotation: 10, transformOrigin: "center center", ease: Elastic.easeOut.config(1, 0.3) })
  .to($iconIdeas.find('.bulb'), 0.5, { scale: 0.9, transformOrigin: "center center", ease: Power4.easeIn }, '+=0.3');

  // 06 - Media
  var $iconMedia = $('*[data-timeline="iconMedia"]');
  timelineIcons.iconMedia = new TimelineMax({ paused: true, repeat: -1 })
  .from($iconMedia.find('.ext'), 1, { y: -10, autoAlpha: 0, ease: Sine.easeIn }, 0.5)
  .from($iconMedia.find('.title'), 1, { scaleY: 0, transformOrigin:'center bottom', ease: Sine.easeIn }, '-=0.5')
  .staggerFrom($iconMedia.find('.lines .line'), .5, { drawSVG: 0 }, 0.15, '-=0.5')
  .to($iconMedia.find('.ext, .lines .line, .title'), 1, { y: -10, autoAlpha: 0, ease: Sine.easeIn }, '+=' + repeatDelay);

  // 07 - Workshops
  var $iconWorkshops = $('.icon[data-timeline="iconWorkshops"]');
  timelineIcons.iconWorkshops = new TimelineLite({ paused: true })
  .from($iconWorkshops.find('.person1'), 0.5, {y:'5px', opacity:'0', ease: Sine.easeIn}, '-=0.3')
  .from($iconWorkshops.find('.person2'), 0.5, {y:'5px', opacity:'0', ease: Sine.easeIn}, '-=0.3')
  .from($iconWorkshops.find('.wrap-cloud1'), 0.5, {x:'5px', opacity:'0', ease: Sine.easeIn}, '-=0.3')
  .from($iconWorkshops.find('.cloud2'), 0.5, {x:'-5px', opacity:'0', ease: Sine.easeIn}, '-=0.3');

  new ScrollMagic.Scene({
    triggerElement: $iconWorkshops[0],
    triggerHook: 0.8
  })
  .on("enter", function (event) {
    loopDotsSecond.play();
  })
  .on("leave", function (event) {
    loopDotsSecond.pause();
  })
  .addTo(controller);

  var loopDotsSecond = new TimelineMax({repeat: -1, repeatDelay: 2, paused: true})
  .staggerFrom($iconWorkshops.find('.dot'), 1, { opacity: 0 }, 0.2 );

  // 08 - BootCamps
  var $iconBootCamps = $('*[data-timeline="iconBootCamps"]');
  timelineIcons.iconBootCamps = new TimelineMax({ paused: true })
  .from($iconBootCamps.find('.wrap-ingr'), 0.5, { autoAlpha: 0, ease: Sine.easeIn}, '-=0.3')
  .from($iconBootCamps.find('.head'), 2, { drawSVG: 0, ease: Sine.easeIn }, 0);

  new ScrollMagic.Scene({
    triggerElement: $iconBootCamps[0],
    triggerHook: 0.8
  })
  .on("enter", function (event) {
    loopIngr.play();
  })
  .on("leave", function (event) {
    loopIngr.pause();
  })
  .addTo(controller);

  var loopIngr = new TimelineMax({repeat: -1, paused: true})
  .to($('.ingr1'), 12, {rotation: '360', transformOrigin: "50% 50%", ease: Power0.easeInOut}, 0)
  .to($('.ingr2'), 12, {rotation: '-360', transformOrigin: "50% 50%", ease: Power0.easeInOut}, 0);
